/**
* Adiciona a funcionalidade de mostrar todos os markers do mapa.
* @author: adalto.junior
* Date: 06/12/13
* Time: 11:44
*/


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};

Greenmile.Toolbar.Map.FitToMarkers = function (tabNameSelector, map) {

  this.__bounds = [];

  this.extractBoundsForLayer = (layers) => {
    var marker;
    var getLatLngFromMarker = markers => {
      for (var marker in markers) {
        var obj = markers[marker];
        this.__bounds.push([obj._latlng.lat, obj._latlng.lng]);
      }
    };
    for (var layer in layers) {
      var __layer = layers[layer];
      if (__layer._childClusters && __layer._childClusters.length) {
        if (__layer._markers.length) {
          getLatLngFromMarker(__layer._markers);
        }
        this.extractBoundsForLayer(__layer._childClusters);
      } else if (__layer.hasOwnProperty('_topClusterLevel')) {
        this.extractBoundsForLayer([__layer._topClusterLevel]);
      } else if (__layer._latlng) {
        marker = __layer._latlng;
        this.__bounds.push([marker.lat, marker.lng]);
      }
    }
  };

  this.showAllMarkers = () => {
    const layers = map._layers;
    this.extractBoundsForLayer(layers);
    if (this.__bounds.length) {
      const boundsFiltered = this.__bounds.filter(coords => coords[0] !== 0)
      if (boundsFiltered.length) {
        map.fitBounds(boundsFiltered);
      }
      this.__bounds = [];
    }
  };

  this.addListeners = () => {
    const btnFitToMarkers = document.querySelector(`${tabNameSelector}  .btnFitToMarkers`);
    if (btnFitToMarkers) {
      btnFitToMarkers.removeEventListener('click', this.showAllMarkers);
      btnFitToMarkers.addEventListener('click', this.showAllMarkers);
    }
  };

};
